import { render, staticRenderFns } from "./PostTrainingVideosEdit.vue?vue&type=template&id=87203b00&"
import script from "./PostTrainingVideosEdit.vue?vue&type=script&lang=js&"
export * from "./PostTrainingVideosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports